module.exports = __webpack_public_path__ + "img/01.d1d180e0.jpg";